//Custom components
import StatCard from '../../../UI/Card/StatCard';

const AverageTimeAtResidenceWidget = ({ count }: { count: number }) => {
  return <StatCard title='Average time at Residence' stat={`${count} Years`} />;
};

export default AverageTimeAtResidenceWidget;
